import { Chess } from 'chess.js';
export function checkPawnStructure(fenBefore, fenAfter) {
    const chessBefore = new Chess(fenBefore);
    const chessAfter = new Chess(fenAfter);
    const side = chessBefore.turn();
    const getPawnCountPerFile = (chess, s) => {
        const files = new Array(8).fill(0);
        for (let i = 0; i < 64; i++) {
            const sq = chess.board().flat()[i];
            if (sq && sq.type === 'p' && sq.color === s) {
                const fileIdx = i % 8;
                files[fileIdx]++;
            }
        }
        return files;
    };
    const beforeFiles = getPawnCountPerFile(chessBefore, side);
    const afterFiles = getPawnCountPerFile(chessAfter, side);
    // Check for new doubled pawns
    for (let i = 0; i < 8; i++) {
        if (afterFiles[i] > beforeFiles[i] && afterFiles[i] >= 2) {
            return {
                id: 'pawn_structure',
                severity: 'low',
                data: { detail: 'doubled_pawns' }
            };
        }
    }
    return null;
}
